var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.977,
    height: 19.172,
    viewBox: "0 0 15.977 19.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M13.982,11.184a.8.8,0,0,1-.8.8H6.793a.8.8,0,0,1,0-1.6h6.391A.8.8,0,0,1,13.982,11.184Zm-3.2,2.4H6.793a.8.8,0,0,0,0,1.6h3.994a.8.8,0,1,0,0-1.6Zm7.189-5.2v6.8a4,4,0,0,1-3.994,3.994H5.994A4,4,0,0,1,2,15.178V3.994A4,4,0,0,1,5.994,0H9.6a5.558,5.558,0,0,1,3.954,1.638l2.783,2.785A5.553,5.553,0,0,1,17.977,8.376ZM12.426,2.767a4,4,0,0,0-.84-.623V5.592a.8.8,0,0,0,.8.8h3.448a3.981,3.981,0,0,0-.624-.839Zm3.953,5.609c0-.132-.026-.258-.038-.387H12.385a2.4,2.4,0,0,1-2.4-2.4V1.635C9.859,1.623,9.732,1.6,9.6,1.6H5.994a2.4,2.4,0,0,0-2.4,2.4V15.178a2.4,2.4,0,0,0,2.4,2.4h7.988a2.4,2.4,0,0,0,2.4-2.4Z",
    transform: "translate(-2 0)",
    fill: "#082654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.7b8ca6cb2bbebb231fa77c3ae36f7f5a.svg";
export { ForwardRef as ReactComponent };